import { formatNumber } from "./format-number"

// format distance meter to km
export const formatDistance = (value) => {
  let distance = value
  if (distance >= 1000) {
    return formatNumber(distance / 1000) + ' km'
  }
  return '< 1 km'
}